export default "__VITE_ASSET__C2TJs$qr__"